import { Component } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'termCond',
    templateUrl: 'term_cond.template.html'
})
// tslint:disable-next-line:eofline
export class TerminosCondicionesComponent {};


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/terminos_condiciones_app/term_cond.component.ts